import {
  Box,
  Breadcrumbs,
  Button,
  Card,
  CardContent,
  CardHeader,
  Container,
  Divider,
  FormControl,
  FormControlLabel,
  InputLabel,
  LinearProgress,
  makeStyles,
  MenuItem,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import PropTypes from "prop-types";
import NumberFormat from "react-number-format";
import _ from "lodash";
import { Formik, Form, Field } from "formik";
import { CheckboxWithLabel, TextField } from "formik-material-ui";

import SaveIcon from "@material-ui/icons/Save";
import CustomSelectInput from "src/components/inputs/CustomSelectInput";

import SelectAllIcon from "@material-ui/icons/SelectAll";

import { fetchCurrencies } from "src/redux/actions/reference.action";
import { useDispatch, useSelector } from "react-redux";
import { priceNumberFormat, sumTotal } from "src/utils/Number";
import {
  addProductJob,
  getJobItemById,
  getPurchaseDetails,
  getPurchaseExpense,
  getPurchaseExpenseJob,
  getPurchaseRequesitionJobById,
  updateProductJob,
} from "src/redux/actions/purchaseRequest.action";
import { Alert, AlertTitle } from "@material-ui/lab";
import ProductItemJobModal from "src/components/modals/ProductItemJobModal/ProductItemJobModal";
import LocationModalComponent from "src/components/modals/LocationModalComponent/LocationModalComponent";
import MyLocationIcon from "@material-ui/icons/MyLocation";
import Swal from "sweetalert2";
import SupplierModal from "src/components/modals/SupplierModal";
import Page from "src/components/Page";
import UnitModalComponent from "src/components/modals/UnitModalComponent";

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
    flexWrap: "wrap",
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "26ch",
    },
    "& .MuiFormControlLabel-root": {
      margin: theme.spacing(1),
    },
    "& .MuiButton-root": {
      margin: theme.spacing(1),
    },
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    overflow: "hidden",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  formContainer: {
    display: "flex",
    flex: 1,
    flexWrap: "wrap",
    justifyContent: "center",
  },
  rootLoading: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: 400,
    padding: 5,
  },
  selectInputForm: {
    margin: theme.spacing(1, 1, 1),
    width: "25ch",
  },
}));

PurchaseJobItemEditComponent.ProductForm = {
  valueForm: PropTypes.object,
  headerId: PropTypes.number,
};

const NumberFormatCustom = (props) => {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        if (values.value > 0) {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        } else {
          onChange({
            target: {
              name: props.name,
              value: 0,
            },
          });
        }
      }}
      thousandSeparator
      isNumericString
      prefix=""
    />
  );
};

NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};
export default function PurchaseJobItemEditComponent() {
  const params = useParams();
  const classes = useStyles();

  const history = useHistory();

  const form = useRef();

  const dispatch = useDispatch();

  const [openModal, setOpenModal] = useState(false);
  const [openSupplierModal, setOpenSupplierModal] = useState(false);
  const [openUnitModal, setOpenUnitModal] = useState(false);

  const {
    result: { currencyid },
  } = useSelector((state) => state.loginReducer);

  const {
    purchaseRequest,
    purchaseRequestJobItem,
    purchaseRequestJob,
    purchaseRequesteExpense,
    purchaseRequesteExpenseJob,
    purchaseRequestDetails,
  } = useSelector((state) => state.purchaseRequestReducer);

  const [openLocationModal, setOpenLocationModal] = useState(false);

  const { currencies } = useSelector((state) => state.referenceReducer);

  useEffect(() => {
    if (form.current) {
      form.current.getFormikActions().validateForm();
    }

    if (params.id) {
      dispatch(getPurchaseRequesitionJobById(params.headerid));
      dispatch(getPurchaseExpenseJob(params.headerid));
      dispatch(getPurchaseExpense(params.headerid));
      dispatch(getPurchaseDetails(params.headerid));
      dispatch(getJobItemById(params.id));
      dispatch(fetchCurrencies(currencyid));
    }

    return () => {};
  }, [params.id]);

  const findExchangeRate = (id) => {
    let result = _.find(currencies.data, { CURRENCY_ID: id });
    if (result) {
      return result.CURRENCY_EXC_ID;
    }
    return 0;
  };

  const renderCurrencies = () => {
    if (currencies.isLoading) {
      return <MenuItem>Loading...</MenuItem>;
    }

    return currencies.data.map((i) => (
      <MenuItem key={i.CURRENCY_ID} value={i.CURRENCY_ID}>
        {i.CURRENCY_EXC_CODE} - {i.CURRENCY_EXC_NAME}
      </MenuItem>
    ));
  };

  if (purchaseRequestJobItem.isLoading) {
    return (
      <div className={classes.root}>
        <LinearProgress color="secondary" />
      </div>
    );
  }

  if (purchaseRequestJobItem.isRejected) {
    return (
      <div className={classes.root}>
        <Alert severity="error">
          <AlertTitle>Error</AlertTitle>
          This is an error alert —{" "}
          <strong>Get Purchase Requisition Job Item!</strong>
        </Alert>
      </div>
    );
  }

  return (
    <Page className={classes.root} title="Purchase Requisition List">
      <Container maxWidth={false}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link
            color="inherit"
            onClick={() => {
              history.replace("/purchase-requisition-job");
            }}
          >
            Purchase Requisition List Job
          </Link>
          <Link
            color="inherit"
            onClick={() => {
              history.goBack();
            }}
          >
            Purchase Requesition Job Edit
          </Link>
          <Link color="textPrimary" aria-current="page">
            Item Form Edit
          </Link>
        </Breadcrumbs>
        <Card>
          <CardHeader
            subheader="For the purchase requisition adjust on the system."
            title="Item Form Edit"
          />
          <Divider />
          <CardContent>
            <div className={classes.formContainer}>
              <Formik
                key={`ProductForm`}
                // ref={form}
                enableReinitialize
                initialValues={{
                  ...purchaseRequestJobItem.data,
                  OLD_AMOUNT: purchaseRequestJobItem.data.AMOUNT
                    ? purchaseRequestJobItem.data.AMOUNT
                    : "",
                  PRJIDX: params.id,
                  CURR_ID: purchaseRequestJobItem.data.CURR_ID
                    ? purchaseRequestJobItem.data.CURR_ID
                    : "",
                  ITEMS_DETAIL: purchaseRequestJobItem.data.ITEMS_DETAIL
                    ? `${purchaseRequestJobItem.data.ITEMS_DETAIL}`
                    : "",
                  SKUIDX: purchaseRequestJobItem.data.SKUIDX
                    ? purchaseRequestJobItem.data.SKUIDX
                    : "",
                  PRICE: purchaseRequestJobItem.data.PRICE
                    ? purchaseRequestJobItem.data.PRICE
                    : "",
                  QTY: purchaseRequestJobItem.data.QTY
                    ? purchaseRequestJobItem.data.QTY
                    : "",
                  PR_UNIT: purchaseRequestJobItem.data.PR_UNIT
                    ? `${purchaseRequestJobItem.data.PR_UNIT}`
                    : "",
                  EXC_RATE: purchaseRequestJobItem.data.EXC_RATE
                    ? `${purchaseRequestJobItem.data.EXC_RATE}`
                    : 0,
                  AMOUNT: purchaseRequestJobItem.data.AMOUNT
                    ? purchaseRequestJobItem.data.AMOUNT
                    : "",
                  DF_AMT_THB: purchaseRequestJobItem.data.DF_AMT_THB
                    ? `${purchaseRequestJobItem.data.DF_AMT_THB}`
                    : 0,
                  DF_PRICE_THB: purchaseRequestJobItem.data.DF_PRICE_THB
                    ? `${purchaseRequestJobItem.data.DF_PRICE_THB}`
                    : 0,
                  BGIDX: purchaseRequestJobItem.data.BGIDX
                    ? `${purchaseRequestJobItem.data.BGIDX}`
                    : "",
                  BUDGET_CODE: purchaseRequestJobItem.data.BUDGET_CODE
                    ? `${purchaseRequestJobItem.data.BUDGET_CODE}`
                    : "",
                  BUDGETP_CODE: purchaseRequestJobItem.data.BUDGETP_CODE
                    ? `${purchaseRequestJobItem.data.BUDGETP_CODE}`
                    : "",
                  REMARK: purchaseRequestJobItem.data.REMARK
                    ? purchaseRequestJobItem.data.REMARK
                    : "",
                  PR_BRANDID: purchaseRequestJobItem.data.PR_BRANDID
                    ? purchaseRequestJobItem.data.PR_BRANDID
                    : null,
                  PR_DEPARTID: purchaseRequestJobItem.data.PR_DEPARTID
                    ? purchaseRequestJobItem.data.PR_DEPARTID
                    : null,
                  PO_TYPE:
                    purchaseRequestJobItem.data.PO_TYPE === 1 ? true : false,
                  VAT_TYPE:
                    purchaseRequestJobItem.data.VAT_TYPE === 1 ? true : false,
                  SUPNAME: purchaseRequestJobItem.data.SUPNAME
                    ? purchaseRequestJobItem.data.SUPNAME
                    : "",
                  D_LOC_CODE: purchaseRequestJobItem.data.D_LOC_CODE
                    ? purchaseRequestJobItem.data.D_LOC_CODE
                    : "",
                }}
                validate={(values) => {
                  const errors = {};

                  if (!values.ITEMS_DETAIL) {
                    errors.ITEMS_DETAIL = "Required";
                  }

                  if (!values.BUDGET_CODE) {
                    errors.BUDGET_CODE = "Required";
                  }

                  if (Number(values.PRICE) < 0) {
                    errors.PRICE = "Required";
                  }

                  if (!values.QTY) {
                    errors.QTY = "Required";
                  }

                  if (Number(values.QTY) <= 0 || Number(values.QTY) > 1000000) {
                    errors.QTY = "Required";
                  }

                  if (!values.PR_UNIT) {
                    errors.PR_UNIT = "Required";
                  }

                  if (!values.SUPNAME) {
                    errors.SUPNAME = "Required";
                  }

                  if (!values.CURR_ID) {
                    errors.CURR_ID = "Required";
                  }

                  if (!values.D_LOC_CODE) {
                    errors.D_LOC_CODE = "Required";
                  }

                  return errors;
                }}
                onSubmit={(values, { setSubmitting, resetForm }) => {
                  setTimeout(() => {
                    setSubmitting(false);

                    const masterAmount = parseFloat(
                      parseFloat(
                        sumTotal(["AMOUNT"], purchaseRequestDetails.data) +
                          (purchaseRequesteExpense.data &&
                            purchaseRequesteExpense.data.AMOUNT)
                      ).toFixed(4)
                    );

                    const jobAmount =
                      sumTotal(["AMOUNT"], purchaseRequestJob.data) +
                      (purchaseRequesteExpenseJob.data &&
                        purchaseRequesteExpenseJob.data.AMOUNT);

                    let currentAmount = 0;

                    if (values.OLD_AMOUNT === values.AMOUNT) {
                      currentAmount = parseFloat(
                        parseFloat(jobAmount).toFixed(4)
                      );
                    } else {
                      currentAmount = parseFloat(
                        parseFloat(
                          jobAmount - values.OLD_AMOUNT + values.AMOUNT
                        ).toFixed(4)
                      );
                    }

                    if (
                      Math.round(currentAmount * 100) <=
                      Math.round(masterAmount * 100)
                    ) {
                      values.BGIDX = Number(values.BGIDX);
                      values.PRICE = Number(values.PRICE);
                      values.PRHIDX = Number(values.PRHIDX);
                      values.QTY = Number(values.QTY);
                      values.CURR_ID = Number(values.CURR_ID);

                      const result = _.find(purchaseRequestJob.data, {
                        CURR_ID: Number(values.CURR_ID),
                      });

                      if (result) {
                        dispatch(
                          updateProductJob(
                            values,
                            values.PR_DEPARTID,
                            values.PR_BRANDID,
                            params.year,
                            params.companyid,
                            history
                          )
                        );
                        resetForm({});
                      } else {
                        Swal.fire({
                          icon: "warning",
                          title: "Warning",
                          text: "Single currency per PR is allowed.",
                        });
                      }
                    } else {
                      Swal.fire({
                        icon: "warning",
                        title: "Warning",
                        text: "The purchase requisition, Should be not over budget of master !",
                      });
                    }
                  }, 500);
                }}
                render={({
                  submitForm,
                  isSubmitting,
                  touched,
                  errors,
                  values,
                  setFieldValue,
                }) => {
                  return (
                    <Form>
                      <div>
                        {isSubmitting && <LinearProgress color="secondary" />}
                        <div>
                          <Button
                            variant="contained"
                            onClick={(e) => {
                              e.preventDefault();
                              setOpenModal(true);
                            }}
                            color="primary"
                          >
                            <SelectAllIcon />
                            CHOOSE ITEM
                          </Button>
                          <Button
                            flex={1}
                            variant="contained"
                            color="primary"
                            style={{
                              alignSelf: "center",
                            }}
                            onClick={(e) => {
                              e.preventDefault();
                              setOpenLocationModal(true);
                            }}
                          >
                            <MyLocationIcon />
                            CHOOSE DELIVERY LOCATION
                          </Button>
                        </div>
                        <hr />
                        <div>
                          <Field
                            component={TextField}
                            name="BUDGET_CODE"
                            label="Budget Code"
                            error={Boolean(
                              errors.BUDGET_CODE && errors.BUDGET_CODE
                            )}
                            fullWidth
                            InputProps={{
                              readOnly: true,
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                          <Field
                            component={TextField}
                            name="BUDGETP_CODE"
                            label="Project Code"
                            fullWidth
                            InputProps={{
                              readOnly: true,
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                          <Field
                            component={TextField}
                            name="ITEMS_DETAIL"
                            label="Item Name"
                            error={Boolean(
                              errors.ITEMS_DETAIL && errors.ITEMS_DETAIL
                            )}
                            fullWidth
                            InputProps={{
                              readOnly: true,
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                          <Field
                            component={TextField}
                            name="PRICE"
                            label="Unit Price"
                            error={Boolean(
                              errors.PRICE && touched.PRICE && errors.PRICE
                            )}
                            onChange={(e) => {
                              if (e.target.value > 0) {
                                setFieldValue("PRICE", e.target.value);

                                if (values.CURR_ID) {
                                  setFieldValue(
                                    "EXC_RATE",
                                    findExchangeRate(values.CURR_ID)
                                  );
                                }

                                if (values.QTY) {
                                  var amount = parseFloat(
                                    parseFloat(
                                      values.EXC_RATE *
                                        e.target.value *
                                        values.QTY
                                    ).toFixed(4)
                                  );
                                  setFieldValue("AMOUNT", amount);
                                }
                              } else {
                                setFieldValue("PRICE", e.target.value);
                                setFieldValue("AMOUNT", 0);
                                if (values.CURR_ID) {
                                  setFieldValue(
                                    "EXC_RATE",
                                    findExchangeRate(values.CURR_ID)
                                  );
                                }
                              }
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            InputProps={{
                              inputComponent: NumberFormatCustom,
                            }}
                          />
                          <FormControl className={classes.selectInputForm}>
                            <InputLabel
                              error={Boolean(
                                errors.CURR_ID &&
                                  touched.CURR_ID &&
                                  errors.CURR_ID
                              )}
                              id="CURR_ID"
                            >
                              Please Select Currency
                            </InputLabel>
                            <Field
                              labelId="CURR_ID"
                              component={CustomSelectInput}
                              name="CURR_ID"
                              // className={classes.selectInputForm}
                              error={Boolean(
                                errors.CURR_ID &&
                                  touched.CURR_ID &&
                                  errors.CURR_ID
                              )}
                              onChange={(e) => {
                                setFieldValue(
                                  "EXC_RATE",
                                  findExchangeRate(e.target.value)
                                );

                                if (values.QTY) {
                                  var amount = parseFloat(
                                    parseFloat(
                                      findExchangeRate(e.target.value) *
                                        values.PRICE *
                                        values.QTY
                                    ).toFixed(4)
                                  );
                                  setFieldValue("AMOUNT", amount);
                                }
                              }}
                            >
                              {renderCurrencies()}
                            </Field>
                          </FormControl>
                        </div>
                        <div>
                          <Field
                            component={TextField}
                            name="QTY"
                            label="QTY"
                            error={Boolean(
                              errors.QTY && touched.QTY && errors.QTY
                            )}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            onChange={(e) => {
                              setFieldValue("QTY", e.target.value);

                              if (values.CURR_ID) {
                                setFieldValue(
                                  "EXC_RATE",
                                  findExchangeRate(values.CURR_ID)
                                );
                              }

                              if (values.PRICE) {
                                var amount = parseFloat(
                                  parseFloat(
                                    values.EXC_RATE *
                                      values.PRICE *
                                      e.target.value
                                  ).toFixed(4)
                                );

                                setFieldValue("AMOUNT", amount);
                              }
                            }}
                            InputProps={{
                              inputComponent: NumberFormatCustom,
                            }}
                          />
                          <Field
                            label="Unit Type (click)"
                            component={TextField}
                            name="PR_UNIT"
                            id="PR_UNIT"
                            error={Boolean(
                              errors.PR_UNIT &&
                                touched.PR_UNIT &&
                                errors.PR_UNIT
                            )}
                            onClick={(e) => {
                              e.preventDefault();
                              setOpenUnitModal(true);
                            }}
                            fullWidth
                            InputLabelProps={{
                              shrink: true,
                              readOnly: true,
                            }}
                          />
                          <Field
                            label="Supplier (Click)"
                            component={TextField}
                            name="SUPNAME"
                            id="SUPNAME"
                            error={Boolean(
                              errors.SUPNAME &&
                                touched.SUPNAME &&
                                errors.SUPNAME
                            )}
                            onClick={(e) => {
                              e.preventDefault();
                              setOpenSupplierModal(true);
                            }}
                            onChange={() => {}}
                            fullWidth
                            InputLabelProps={{
                              shrink: true,
                              readOnly: true,
                            }}
                          />
                          <Field
                            label="Delivery Location (click)"
                            component={TextField}
                            name="D_LOC_CODE"
                            id="D_LOC_CODE"
                            error={Boolean(
                              errors.D_LOC_CODE &&
                                touched.D_LOC_CODE &&
                                errors.D_LOC_CODE
                            )}
                            onClick={(e) => {
                              e.preventDefault();
                              setOpenLocationModal(true);
                            }}
                            onChange={() => {}}
                            fullWidth
                            InputLabelProps={{
                              shrink: true,
                              readOnly: true,
                            }}
                          />
                        </div>
                        <div>
                          <FormControlLabel
                            label="Generate PO"
                            control={
                              <Field
                                id="PO_TYPE"
                                name="PO_TYPE"
                                type="checkbox"
                                component={CheckboxWithLabel}
                              />
                            }
                          />
                        </div>
                        <div>
                          <Typography variant="h6" gutterBottom>
                            Total Amount : {priceNumberFormat(values.AMOUNT)}
                            {"   "}
                          </Typography>
                          <Box display="flex" justifyContent="flex-end">
                            <Box>
                              <Button
                                onClick={submitForm}
                                variant="contained"
                                color="primary"
                              >
                                <SaveIcon />
                                Save
                              </Button>
                            </Box>
                            <Box marginLeft={2}>
                              <Button
                                disabled={isSubmitting}
                                onClick={() => {
                                  history.goBack();
                                }}
                                variant="contained"
                              >
                                Cancel
                              </Button>
                            </Box>
                          </Box>
                        </div>
                      </div>
                      <UnitModalComponent
                        open={openUnitModal}
                        handleClose={() => {
                          setOpenUnitModal(false);
                        }}
                        handleAdd={(value) => {
                          const { REF_CODE } = value;
                          setFieldValue("PR_UNIT", REF_CODE);
                        }}
                      />
                      <LocationModalComponent
                        open={openLocationModal}
                        countryid={purchaseRequest.data.PR_COUNTRYID}
                        handleClose={() => {
                          setOpenLocationModal(false);
                        }}
                        handleAdd={(value) => {
                          const { REF_NAME, REF_RCIDX, REF_CODE } = value;
                          setFieldValue("D_LOC_NAME", REF_NAME);
                          setFieldValue("D_LOC", REF_RCIDX);
                          setFieldValue("D_LOC_CODE", REF_CODE);
                        }}
                      />
                      <SupplierModal
                        open={openSupplierModal}
                        handleAdd={(value) => {
                          setFieldValue("SUPCODE", value.SUPCODE);
                          setFieldValue("SUPNAME", value.NAMETHAI);
                        }}
                        handleClose={() => setOpenSupplierModal(false)}
                      />
                      <ProductItemJobModal
                        open={openModal}
                        handleClose={() => {
                          setOpenModal(false);
                        }}
                        countryid={params.countryid}
                        companyid={params.companyid}
                        budgetcode={params.budgetcode}
                        year={params.year}
                        secureid={params.secid}
                        column={[
                          {
                            title: "Budget Code",
                            field: "ACC_CODE",
                          },
                          { title: "Items Code", field: "STYLECODE" },
                          {
                            title: "Item Name",
                            field: "NAME_TH",
                            cellStyle: {
                              whiteSpace: "nowrap",
                            },
                          },
                          {
                            title: "Description",
                            field: "DESCRIP_TH",
                            cellStyle: {
                              whiteSpace: "nowrap",
                            },
                          },
                          {
                            title: "Detail",
                            field: "ACCDETAIL",
                            cellStyle: {
                              minWidth: 600,
                              whiteSpace: "nowrap",
                            },
                          },
                        ]}
                        handleAdd={(value) => {
                          const result = _.find(purchaseRequestJob.data, {
                            BGIDX: Number(value.BGIDX),
                          });

                          if (result) {
                            setFieldValue(
                              "PR_DEPARTID",
                              value.BUDGETS_DEPARTMENT
                            );
                            setFieldValue("PR_BRANDID", value.BUDGETS_BRAND);
                            setFieldValue("ITEMS_DETAIL", value.NAME_TH);
                            setFieldValue("SKUIDX", value.SKUIDX);
                            setFieldValue("BUDGET_CODE", value.ACC_CODE);
                            setFieldValue("BGIDX", value.BGIDX);
                            setFieldValue("PR_UNIT", value.UNIT_NAME);
                          } else {
                            Swal.fire({
                              icon: "warning",
                              title: "Warning",
                              text: "The purchase requisition, Should use the same the budget code on used!",
                            }).then(() => {
                              setOpenModal(true);
                            });
                          }
                        }}
                      />
                    </Form>
                  );
                }}
              />
            </div>
          </CardContent>
        </Card>
      </Container>
    </Page>
  );
}
